/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export enum Environments {
  LOCAL = 'local',
  DEV = 'dev',
  QA = 'qa',
  UAT = 'uat',
  PROD = 'prod',
}
